import { WSJob } from '@local/finsera-core/src/types/job';

import { JOB_UPDATE } from '../actions/types';

const INITIAL_STATE = {
  lastJobCompleted: { id: -1 } as WSJob,
  runningJobs: [] as WSJob[],
  completedJobIds: new Set<number>(),
};

type JobsState = typeof INITIAL_STATE;

export type JobCompletedActionType = {
  type: typeof JOB_UPDATE;
  job: WSJob;
};

const jobsReducer = (state: JobsState = INITIAL_STATE, action: JobCompletedActionType): JobsState => {
  switch (action.type) {
    case JOB_UPDATE: {
      if (action.job.completed_at && state.completedJobIds.has(action.job.id)) {
        // This job was already flagged as completed.
        return state;
      }

      const newState = { ...state };
      newState.runningJobs = newState.runningJobs.filter((j) => j.id !== action.job.id);

      if (!action.job.canceled) {
        if (action.job.completed_at) {
          newState.lastJobCompleted = action.job;
          newState.completedJobIds = new Set([...state.completedJobIds, action.job.id]);
        } else {
          newState.runningJobs = [...newState.runningJobs, action.job];
        }
      }

      return newState;
    }
    default:
      return state;
  }
};

export default jobsReducer;
